<div class="w-full bg-light min-h-screen flex flex-col">
  <app-baner-publicity></app-baner-publicity>
  <app-header-home
    [typeJobs]="jobTypes"
    [locations]="province"
    (filtersChanged)="onHeaderFiltersChanged($event)"
  >
  </app-header-home>
  <main class="flex flex-col lg:flex-row w-full grow pt-4">
    <section class="w-full lg:w-1/4 px-4">
      <app-filter-section
        [loading]="isLoading"
        (filtersChanged)="onSectionFiltersChanged($event)"
      >
      </app-filter-section>
    </section>
    <section class="w-full lg:w-2/4 px-4 flex flex-col">
      <app-list-section
        [jobs]="jobs"
        [isLoading]="isLoading"
        class="shrink-0"
      ></app-list-section>
      @if (!isLoading && pagination.total > 0) {
      <div
        class="flex flex-col sm:flex-row items-center justify-between mt-5 mb-5 gap-3 text-center sm:text-left"
      >
        <div
          class="text-xs sm:text-sm text-gray-600 hidden sm:block lg:block md:hidden"
        >
          Mostrando {{ showingFrom }} - {{ showingTo }} de
          {{ pagination.total }}
        </div>
        <div
          class="flex items-center space-x-1 sm:space-x-2 flex-wrap justify-center w-full sm:w-auto"
        >
          <button
            (click)="prevPage()"
            [disabled]="pagination.current === 1"
            [ngClass]="{
              'cursor-not-allowed opacity-50 bg-gray-200 border-gray-300 text-gray-400':
                pagination.current === 1,
              'hover:bg-primary hover:border-primary hover:text-white':
                pagination.current !== 1
            }"
            class="px-3 py-1 flex items-center justify-center border rounded transition text-sm"
          >
            ‹
          </button>
          <ng-container *ngFor="let page of pagesToShow">
            <button
              *ngIf="page !== -1"
              (click)="goToPage(page)"
              [class.bg-primary]="pagination.current === page"
              [class.text-white]="pagination.current === page"
              class="px-3 py-1 border border-gray-400 text-gray-700 rounded hover:bg-primary hover:border-primary hover:text-white transition text-sm"
            >
              {{ page }}
            </button>
            <span *ngIf="page === -1" class="px-2">...</span>
          </ng-container>
          <button
            (click)="nextPage()"
            [disabled]="pagination.current === pagination.lastPage"
            [ngClass]="{
              'cursor-not-allowed opacity-50 bg-gray-200 border-gray-300 text-gray-400':
                pagination.current === pagination.lastPage,
              'hover:bg-primary hover:border-primary hover:text-white':
                pagination.current !== pagination.lastPage
            }"
            class="px-3 py-1 flex items-center justify-center border rounded transition text-sm"
          >
            ›
          </button>
        </div>
      </div>
      }
    </section>
    <section class="w-full lg:w-1/4 px-4">
      <app-top-section [jobs]="jobOffers"></app-top-section>
    </section>
  </main>
</div>
